exports.default = {
  'copy_success': '复制{text}成功',
  'copy_failed': '复制{text}失败',
  'just_now': '刚刚',
  'minutes_ago': '{diff}分钟前',
  'hours_ago': '{diff}小时前',
  'yesterday': '昨天',
  'month_day': '{month}月{date}日',
  'sun': '日',
  'mon': '一',
  'tue': '二',
  'wed': '三',
  'thu': '四',
  'fri': '五',
  'sat': '六',
  'year': '年',
  'month': '月',
  'day': '日',
  'login_invalid': '登录失效',
  'account_logged_elsewhere': '帐号已在其他地方登录！',
  'backend_exception': '后端接口{code}异常',
  'network_connection_failed': '网络连接失败，请检查您的网络',
  'backend_request_timeout': '后端接口请求超时',
  'backend_exception_code': '后端接口{code}异常',
  'backend_unknown_exception': '后端接口未知异常'
}
